export default {
    agreement__title__first: "СОГЛАШЕНИЕ О ПРАВАХ ",
    agreement__title__second: "ИСПОЛЬЗОВАНИЯ ИНФОРМАЦИОННОЙ СИСТЕМЫ «eQonaq»",

    "agreement_1": [
        {
            "1": "Общие положения",
            "2": "Настоящее Пользовательское соглашение (далее - Соглашение) регламентирует взаимоотношения между Владельцем, Администратором и Пользователем веб-портала «eQonaq» и его компонентов.",
            "3": "В настоящем Соглашении используются следующие понятия:",
            "4": "информационная система",
            "5": "информационная система по сбору и обработке единого реестра мест размещения туристов, туристического потока, а также контроль над соблюдением миграционного законодательства РК посредством уведомления государственных органов о прибытии туристов;",
            "6": "разделы информационной системы",
            "7": "части информационной системы, специализированные на предоставлении отдельных электронных услуг, информации и (или) сервисов;",
            "8": "электронная услуга (далее - Услуга)",
            "9": "предоставление физическим и юридическим лицам, зарегистрированным в информационной системе в качестве пользователей;",
            "10": "владелец информационной системы (далее - Владелец)",
            "11": "Министерство культуры и спорта Республики Казахстан;",
            "12": "пользователь информационной системы (далее - Пользователь)",
            "13": "физическое или юридическое лицо, принявшее условия настоящего Соглашения, зарегистрированное в информационной системе по средствам ЭЦП, и использующее ее услуги для уведомления государственных органов о прибытии туристов в рамках действующего законодательства Республики Казахстан;",
            "14": "администратор информационной системы (далее - Администратор)",
            "15": "AO",
            "16": "НК",
            "17": "мобильное приложение",
            "18": "это программа, установленная и запущенная на мобильном устройстве Пользователя и предоставляющая доступ к ИС  «eQonaq»; посредством сети сотовой связи и Интернет;",
            "19": "электронная цифровая подпись (далее - ЭЦП)",
            "20": "набор электронных цифровых символов, созданный средствами электронной цифровой подписи и подтверждающий достоверность электронного документа, его принадлежность и неизменность содержания;",
            "21": "Все иные термины и определения, используемые в настоящем Соглашении, истолковываются в соответствии с действующим законодательством Республики Казахстан."            

        }
    ],
    "agreement_2": [
        {
            "1": "Предмет Соглашения",
            "2": "Настоящее Соглашение является публичной офертой. Получая доступ к материалам информационной системы, Пользователь считается присоединившимся и принявшим все условия настоящего Соглашения.",
            "3": "Администратор вправе с согласия Владельца в любое время в одностороннем порядке изменять условия настоящего Соглашения. Такие изменения вступают в силу по истечении 3 (трех) дней с момента размещения новой версии Соглашения, с одновременной утратой предыдущей версии Соглашения.",
            "4": "При несогласии Пользователя с Соглашением или внесенными изменениями он обязан отказаться от доступа к ИС «eQonaq»; и прекратить использование материалов и сервисов ИС «eQonaq»;.",
            "5":"Электронный адрес, указанный Пользователем в форме регистрации в информационной системе, предназначен для получения уведомлений в случае:",
            "6": "подписки Пользователем на получение различных служебных уведомлений;",
            "7": "восстановления пароля;",
            "8": "получения сгенерированного нового пароля.",
            "9": "Принимая условия настоящего Соглашения, Пользователь тем самым дает письменное согласие на сбор, обработку, хранение, выгрузку и использование его персональных данных и иной представленной Пользователем в информационной системе информации в целях оказания ему услуг посредством ИС «eQonaq»;, а также улучшения качества предоставляемых (оказываемых) Услуг.",
                    
            
       
        }
    ],
    "agreement_3": [
        {
            "1": "Права и обязанности Сторон",
            "2": "Владелец и Администратор вправе:",
            "3": "В случае необходимости проверять достоверность введенных данных Пользователя, в том числе путем обращения в государственные органы и иные организации.",
            "4": "Направлять Пользователю уведомления информационного характера.",
            "5": "В случае нарушения Пользователем условий настоящего Соглашения отказать в регистрации Пользователя, удалить или заблокировать учетную запись Пользователя.",
            "6": "Пользователь вправе:",
            "7": "Получать консультационную и практическую помощь от Администратора в части пользования ИС «eQonaq»;, написав соответствующий запрос в разделе «Поддержка»; ИС «eQonaq»;.",
            "8": "Владелец и Администратор обязаны:",
            "9": "Обеспечить конфиденциальность персональных данных Пользователя путем недопущения их разглашения без согласия Пользователя либо наличия иного законного основания.",
            "10": "Обеспечить функционирование ИС «eQonaq»;.",
            "11": "Сохранять в тайне от посторонних лиц, не связанных с процессом обмена данными, вверенный пароль для доступа Пользователя к ИС «eQonaq»;, за исключением случаев, предусмотренных законодательством Республики Казахстан.",
            "12": "Пользователь обязан:",
            "13": "Для получения услуг ИС «eQonaq»; пройти процедуру регистрации.",
            "14": "При этом до регистрации в ИС«eQonaq»; необходимо:",
            "15": "физическим лицам из числа граждан Республики Казахстан и имеющих вид на жительство в Республике Казахстан - иметь действующую ЭЦП, выданную Национальным удостоверяющим центром РК, применяемую в сфере «электронного правительства»;",
            "16": "юридическим лицам, зарегистрированным в Республике Казахстан; действующую ЭЦП, выданную Национальным удостоверяющим центром РК, применяемую в сфере «электронного правительства»;.",
            "17": "Предоставить Владельцу и Администратору точную и полную информацию по пунктам, предлагаемым в форме регистрации в ИС «eQonaq».",
            "18": "При работе в ИС «eQonaq»; не выдавать себя за другое лицо, не использовать материалы, содержащие вирусы или другое вредоносное программное обеспечение, использовать собственную ЭЦП.",
            "19": "Не использовать ИС «eQonaq»; и полученную в информационной системе информацию в целях терроризма, экстремизма, разжигания межнациональной розни и в иных запрещенных законодательством Республики Казахстан целях."
        }
    ],
    "agreement_4": [
        {
            "1": "Ответственность сторон",
            "2": "В случае нарушения условий настоящего Соглашения, повлекшего причинение вреда всем или одной из сторон Соглашения, виновная сторона несет ответственность в соответствии с законодательством Республики Казахстан.",
            "3": "Администратор не несет ответственности за технические временные сбои и перерывы в работе ИС «eQonaq»;, возникшие по независящим от Администратора, Владельца причинам или в случае проведения плановых или внеплановых мероприятий по обслуживанию ИС «eQonaq»;.",
            "4": "Владелец и Администратор не несут ответственности за временные сбои и перерывы в работе линий связи, иные аналогичные сбои, а также за неполадки компьютера, мобильного устройства связи, с которого Пользователь осуществляет доступ к ИС «eQonaq»;.",
            "5": "Владелец и Администратор не несут ответственности за любой прямой, косвенный ущерб, включая упущенную выгоду, ущерб от использования, потерю данных или какие-либо другие нематериальные потери, ущерб репутации и иной ущерб, возникающий вследствие:",
            "6": "пользования или невозможности пользования ИС «eQonaq»; Пользователями;",
            "7": "изменения условий Соглашения Владельцем и (или) Администратором.",
            "8": "Пользователь несет полную ответственность за достоверность предоставляемых данных при регистрации в ИС «eQonaq»;, за достоверность сведений, передаваемых для оказания услуг посредством ИС «eQonaq»;.",
            "9": "Пользователь принимает на себя все риски и возможный ущерб, возникший в результате предоставления ими недостоверных сведений о себе, а также за передачу собственных данных, третьим лицам связанных с регистрацией в ИС «eQonaq»;.",
        }
    ],
    "agreement_5": [
        {
            "1": "Прочие положения",
            "2": "Все возможные споры, вытекающие из настоящего Соглашения или связанные с ним, подлежат разрешению в соответствии с действующим законодательством Республики Казахстан.",
            "3": "Нажимая на кнопку «Дальше» Вы подтверждаете, что ознакомлены со всеми пунктами настоящего Соглашения и принимаете их.",
            "4": "Дальше"
        }
    ],
    
    
    
    link_to_main_video: 'https://www.youtube.com/embed/YpPXms28b2s',
    "notif_button": "Отправить уведомление о прибытии гостя",
    "notif_button_mobile": "Отправить уведомление",
    change__password__description: "Ваш пароль должен содержать символы верхнего и нижнего регистра, цифры",
    link__all__adress: "Показать все адреса",
    not__added__text: "не добавлен",
    dowload__pdf__list: "Скачать справку (pdf)",
    residents__list: "Проживающие",
    left__list: "Выезд",
    removed__list: "Удаленный",
    remove__list: "Удалить",
    recovery__list: "Восстановить",
    menu__header__title: "Меню",
    all__tab__list__name: "Все",
    residents__tab__list__name: "Проживающие", 
    retired__tab__list__name: "Выбывшие",
    deleted__tab__list__name: "Удаленные",
    not__list__guest: "У вас нет списка гостей",
    modal__feadback: "Пожалуйста, опишите цель обращения, суть вопроса, укажите свое имя, номер телефона, чтобы в случае необходимости была возможность связаться с вами.",
    modal__title: "Обратная связь",
    modal_title_message: "Сообщение",
    modal_name_error: "Поле 'Имя' обязателен к заполнению",
    modal_phone_error: "Поле 'Телефон' обязателен к заполнению",
    modal_message_error: "Поле 'Сообщение' обязателен к заполнению",
    modal_send_button: "Отправить",
    support__description__one: "Служба поддержки:",
    support__description__two: "Телефон:",
    header__menu__auth: "АВТОРИЗАЦИЯ",
    header__sign__title: "Вход",
    guest__notif__pending: "В обработке",
    guest__notif__nothing: "Нет данных",
    guest__notif__failed: "Ошибка",
    news__title: "Новости",
    "menu_header": [
        {
            "name": "главная",
            "to": "/",
            "url": false
        },
        {
            "name": "Личный кабинет",
            "to": "/login",
            "url": false
        },
        {
            "name": "МИГРАЦИОННЫЙ СПРАВОЧНИК",
            "to": "/migration",
            "url": false
        },
        {
            "name": "Новости",
            "to": "/news",
            "url": false
        },
        {
            "name": "забронировать отель",
            "to": "https://kazakhstan.travel/hotels",
            "url": true
        },
        {
            "name": "полезные контакты",
            "to": "/telephones",
            "url": false
        },
        {
            "name": "Связь",
            "to": "/connection",
            "url": false
        },
        {
            "name": "ВАЛЮТА",
            "to": "/currency",
            "url": false
        },
        {
            "name": "3D - туры о Казахстане",
            "to": "https://kazakhstan.travel/threedtours",
            "url": true
        },
        {
            "name": "Маршруты",
            "to": "https://kazakhstan.travel/tours",
            "url": true
        },
        {
            "name": "О визе в Казахстан",
            "to": "https://kazakhstan.travel/tourist-help/ru/documents",
            "url": true
        },
        {
            "name": "Часовые пояса",
            "to": "https://kazakhstan.travel/tourist-help/ru/time_zones",
            "url": true
        },
        {
            "name": "О Погоде",
            "to": "https://kazakhstan.travel/tourist-help/ru/weather",
            "url": true
        },
        {
            "name": "Языковой справочник",
            "to": "https://kazakhstan.travel/tourist-help/ru/language",
            "url": true
        },
        {
            "name": "Транспорт",
            "to": "https://kazakhstan.travel/tourist-help/ru/transport",
            "url": true
        },
        {
            "name": "Полезные ресурсы",
            "to": "https://kazakhstan.travel/tourist-help/ru/resources",
            "url": true
        },
        {
            "name": "Публикации о Казахстане",
            "to": "https://kazakhstan.travel/tourist-help/ru/phones",
            "url": true
        }
    ],
    "baner__title": "К ВАМ ПРИБЫЛ ИНОСТРАННЫЙ ГОСТЬ?",
    "baner__description": "Согласно Постановлению Правительства № 148 от 21 января 2012 года вы обязаны в течение 3-х дней проинформировать органы внутренних дел.",
    "baner__morree": "Подробнее...",
    "baner__array": [
        {
            "id": 1,
            "img": require('../assets/icons/smart__phone.svg'),
            "text": "Авторизуйтесь в системе или мобильном приложении eQonaq"
        },
        {
            "id": 2,
            "img": require('../assets/icons/smart__face.svg'),
            "text": "Отсканируйте документ иностранца или внесите данные вручную"
        },
        {
            "id": 3,
            "img":  require('../assets/icons/smart__card.svg'),
            "text": "Результат услуги будет доступен в личном кабинете"
        }
    ],
    welcome__title: "Добро пожаловать в информационную cистему eQonaq",
    welcome__description__one: '«eQonaq» - это единая информационная система учета туристов. «eQonaq» собирает и обрабатывает данные от принимающих лиц, осуществляет анализ туристического потока и миграционный контроль. Система создает благоприятный туристический климат (задача №4 Госпрограммы) за счет упрощения процедуры регистрации иностранных граждан, повышает качество предоставления туристических услуг и уровень защищенности государства.',
    welcome__description__two: 'Внедрение осуществляется в рамках программы по развитию туризма 2019-2025 Министерством Культуры и Спорта при содействии Министерства Внутренних дел и Комитета Национальной Безопасности',
    welcome__task__title: "Основные задачи",
    welcome__service: [
        {
            img: require('../assets/icons/1.svg'),
            text: 'Улучшение туристического климата.'
        },
        {
            img: require('../assets/icons/2.svg'),
            text: 'Автоматизация уведомления о прибытии иностранного туриста ст. 518 КОАП.'
        },
        {
            img: require('../assets/icons/3.svg'),
            text: 'Создание единого реестра мест размещения. Анализ туристического потока.'
        },
        {
            img: require('../assets/icons/4.svg'),
            text: 'Миграционный контроль. Повышение уровня защищенности государства.'
        },
        {
            img: require('../assets/icons/5.svg'),
            text: 'Инфраструктура для учета туристического сбора Bed-Tax.'
        },
        {
            img: require('../assets/icons/6.svg'),
            text: 'Сервисы для повышения качества туристических услуг'
        },
    ],
    interesting__places__title: 'Интересные места',
    interesting__places: [
        {
            title: 'УЗНАЙТЕ БОЛЬШЕ О КАЗАХСТАНЕ НА kazakhstan.travel',
            img: require('../assets/all/pr_img0.png'),
            uri: 'https://kazakhstan.travel/publications/ru/15/10-must-see-landscapes-in-kazakhstan',
            sub_logo: require('../assets/all/travelLogo.svg')
        },
        {
            title: 'ОТДЫХ НА Открытом воздухе',
            img: require('../assets/all/pr_img1.png'),
            uri: 'https://kazakhstan.travel/publications/ru/15/10-must-see-landscapes-in-kazakhstan'
        },
        {
            title: 'АРХИТЕКТУРА',
            img: require('../assets/all/pr_img2.png'),
            uri: 'https://kazakhstan.travel/publications/ru/108/seven-architectural-wonders-of-kazakhstan'
        },
        {
            title: 'Куда съездить',
            img: require('../assets/all/pr_img3.png'),
            uri: 'https://kazakhstan.travel/'
        },
    ],
    bookhotel__title: 'Забронировать отель / гостиницу',
    bookhotel__descriptions: 'Найдите спецпредложения от отелей, домов и других вариантов',
    bookhotel__city: 'Куда вы хотите поехать?',
    bookhotel__arrival: 'Заезд',
    bookhotel__departure: 'Отъезд',
    book__hotel__users: 'Взрослых',
    book__hotel__numbers: 'Номер',
    book__hotel__get__price: 'Посмотреть предложения',
    book__hotel__applications__title: 'Полезные приложения',
    book__hotel__footer__reg: 'ЗАРЕГИСТРИРОВАТЬСЯ',
    book__hotel__footer__login: 'АВТОРИЗОВАТЬСЯ',
    footer__contact: "Контакты",
    footer__contact__feadback: "Обратная связь",
    footer__info: 'ИНФОРМАЦИЯ',
    login__description: "Согласно Законодательству Республики Казахстан, вы несете персональную ответственность за корректность предоставляемых данных в систему «eQonaq».",

    // Вы входите в информационную систему «eQonaq». Вы несете персональную ответственность за ваши действия, согласно НТД по информационной безопасности, а также Законодательства Республики Казахстан. Уведомляем, все ваши действия будут записаны в системный журнал.
    footer__menu__info: [
        {
            name: 'О системе',
            to: '',
            type_route: 'on_page',
        },
        {
            name: 'Миграционный справочник',
            to: '/migration',
            type_route: 'on_site',
        },
        {
            name: 'Забронировать отель',
            to: 'https://kazakhstan.travel/hotels',
            type_route: 'on_new_site',
        },
    ],

    auth__login__title: 'Войти в eQonaq?',
    auth__login__descriptions: 'Выберите способ авторизации',
    auth__reg__title: 'Впервые на eQonaq?',
    auth__reg__button: 'ЗАРЕГИСТРИРОВАТЬСЯ',
    auth__reg__modal__title: 'Зарегистрироваться как',
    auth__reg__modal__btn__individuals: 'Физическое лицо',
   
    auth__reg__modal__btn__entities: ' Юридическое лицо',
    auth__reg__modal__btn__ip: 'Индивидуальный предприниматель',
    tabs_array__name__eds: 'ЭЦП',
    tabs_array__name__login: 'Логин',
    eds__btn: 'Выбрать сертификат',
    login__label__password: 'Пароль',
    login__btn: 'Войти',
    login__forgot__password: 'Забыли пароль?',
    nav__bar__title: 'Назад',
    registration__title: 'Регистрация',
    registration__description: 'Для регистрации вам необходим ЭЦП ключ, который вы можете получить по {action}',
    registration__description_link: 'ссылке.',
    registration__eds__btn: 'Выбрать ЭЦП',
    forgot__password__page__title: 'Восстановления пароля',
    forgot__password__page__input__placeholder: 'Введите электронный адрес',
    forgot__password__page__btn: 'Отправить',
    fead__back__toast: "Обратная связь",
    telephones__page__title: 'Полезные номера телефонов',
    telephones__page__description: 'Вызов экстренных служб с любого оператора сотовой связи и городских номеров производится в Казахстане бесплатно',
    telephones__page__phones: [
        {
            title: 'служба аварийно-спасательных работ (служба спасения)',
            number: '112',
            phone: 'tel:112',
        },
        {
            title: 'противопожарная служба',
            number: '101',
            phone: 'tel:101',
        },
        {
            title: 'полиция',
            number: '102',
            phone: 'tel:102',
        },
        {
            title: 'скорая медицинская помощь',
            number: '103',
            phone: 'tel:103',
        },
        {
            title: 'заказ международных и межугородных звонков',
            number: '171',
            phone: 'tel:171',
        },
        {
            title: 'справочная служба операторов местной телефонной связи',
            number: '118',
            phone: 'tel:118',
        },
        {
            title: 'платная информационная служба',
            number: '169',
            phone: 'tel:169',
        },
    ],
    migration__page__title: 'Миграционный справочник',
    migration__page__description: 'Миграционный справочник - это справочник с данными о необходимости визы для прибывания в Республики Казахстан. Также информация о безвизовом нахождений туриста.',
    migration__page__description__two: 'Для получения элекронной визы необходимо обратиться в визово-миграционный портал {action}',
    migration__select__label: 'Выберите страну',
    migration__select__description: 'Турист может прибывать в Республике Казахстан без визы в течении {number__text} дней, если свыше указанного срока необходимо оформление визы.',
    migration__day: 'Безвизовый въезд',
    migration__visa: 'Электронная виза (eVisa)',
    migration__day__text: 'Дней',
    migration__visa__yes: 'Да',
    migration__visa__no: 'Нет',
    header__user__toast: 'Вход/регистрация',
    header__user__menu__cabinet: 'Личный кабинет',
    header__user__menu__sign__out: 'Выход',
    header__user__menu__sign__out__toast: 'Вы вышли с личного кабинета',
    auth__modal__requires__title: 'Требуется авторизация или регистрация',
    eds__page__warnings: 'Для работы с ЭЦП на информационной системе “eQonaq” необходимо обновить/скачать NCALayer по {action}',
    eds__link__text: 'ссылке',
    eds__nclaer__disabled: 'Убедитесь, что программа NCALayer запущена',
    connection__page__title: 'Информация о связи',
    connection__page__text__cards: 'Практически вся территория Казахстана находится в зоне охвата мобильной связью. Основные операторы мобильной связи в Казахстане:',
    connection__page__text__paragraf_one: 'Какой из них воспользоваться, если вы будете путешествовать вблизи городов и крупных населённых пунктов, принципиальной разницы нет. Если же ваша поездка предполагается в удалённые регионы страны, с преодолением длительных дистанций по бескрайним степным просторам, лучше купить сим-карту крупнейших операторов Kcell или Beeline. Их сети покрывают даже практически незаселённые территории.',
    connection__page__text__paragraf_two: 'С сим-карты любого перечисленного выше оператора можно осуществлять звонки по междугородней и международной связи, есть доступ в интернет на базе беспроводных технологий, Wi-Fi. Предлагается большое количество digital-опций:',
    connection__page__text__paragraf_threa_bold: 'мобильные финансы, {break}  мультимедийные сервисы, {break} конвергентные услуги, {break} а также M2M-, MDM-, E2E-решения.',
    connection__page__text__paragraf_four: 'Как правило, сама сим-карта стоит совсем недорого и в стоимость практически всегда включён небольшой баланс. Далее вы переходите на нужный вам тариф. Тарифы действуют различные, информацию о них вам предоставят здесь же, в точках продаж сим-карт, там же помогут перейти с одной опции на другую.',
    connection__page__text__paragraf_five: 'Приобрести сим-карты возможно даже в магазинчиках у дороги. Но в крупных точках продаж в международных аэропортах, на вокзалах, в торговых центрах будет больше выбор, а также больше шансов, что продавец знает английский язык и, соответственно, максимально сможет вам во всём помочь!',
    connection__page__text__paragraf_six: 'Необходимый перечень документов для регистрации номеров/оформления договора с абонентом предоставлен ниже.',
    connection__page__text__paragraf_seven: 'Физическое лицо – резидент РК предоставляет один из следующих удостоверяющих личность документов:',
    connection__page__text__paragraf_eight_bold: 'паспорт гражданина Республики Казахстан; {break} удостоверение личности гражданина Республики Казахстан; {break} вид на жительство иностранца в Республике Казахстан; {break} удостоверение лица без гражданства; {break} свидетельство о рождении.',
    connection__page__text__paragraf_nine: 'Физическое лицо – нерезидент Республики Казахстан: паспорт.',
    page__404__title: 'Страница не найдена',
    page__404__btn: 'На главную',
    modal__reference__title: 'Административный Кодекса РК',
    modal__reference__type__police__list: [
        {
            title: 'Согласно пункту 9 Постановлению Правительства Республики Казахстан от 21 января 2012 года № 148:',
            text: 'Принимающие лица информируют органы внутренних дел о пребывающих у них иммигрантах в течение трех рабочих дней со дня их прибытия.',
        },
        {
            title: 'Согласно пункту 10.1 статьи 1 Закону о миграции: ',
            text: 'Принимающее лицо - гражданин Республики Казахстан, иностранец и лицо без гражданства, постоянно проживающие в Республике Казахстан, или юридическое лицо, зарегистрированное в Республике Казахстан, ходатайствующие о приглашении иммигрантов в Республику Казахстан для временного проживания и (или) предоставляющие место для их проживания.'
        }
    ],
    modal__reference__police__scroll__title: 'В случае не соблюдения требовании законодательства, согласно статье 518 Административного Кодекса РК:',
    modal__reference__police__scroll__text__one: '1. Непринятие принимающим лицом мер по своевременной регист рации иностранцев и лиц без гражданства либо оформлению документов на право их пребывания в Республике Казахстан, либо их выезду из Республики Казахстан по истечении определенного срока пребывания, либо несвоевременное информирование органов внутренних дел о пребывающих у них иммигрантах – влечет предупреждение на физических лиц, штраф на должностных лиц, субъектов малого предпринимательства или некоммерческие организации в размере десяти, на субъектов среднего предпринимательства – в размере пятнадцати, на субъектов крупного предпринимательства – в размере двадцати месячных расчетных показателей.',
    modal__reference__police__scroll__text__two: '2. Предоставление жилища иностранцу или лицу без гражданства, пребывающему в Республике Казахстан с нарушением законодательства Республики Казахстан в области миграции населения либо уклонение от выезда из Республики Казахстан в установленные сроки, либо несоответствие фактического места проживания адресу, указанному при регистрации, – влекут штраф на физических лиц в размере двадцати пяти, на должностное лицо, на субъектов малого предпринимательства или некоммерческие организации – в размере сорока, на субъектов среднего предпринимательства – в размере пятидесяти пяти, на субъектов крупного предпринимательства – в размере семидесяти пяти месячных расчетных показателей.',
    modal__reference__police__scroll__text__threa: '3. Действия, предусмотренные частями первой и второй настоящей статьи, совершенные повторно в течение года после наложения административного взыскания, – влекут штраф на физических лиц в размере тридцати, на должностное лицо, на субъектов малого предпринимательства или некоммерческие организации – в размере сорока, на субъектов среднего предпринимательства – в размере семидесяти, на субъектов крупного предпринимательства – в размере ста месячных расчетных показателей.',
    modal__reference__police__scroll__btn: 'Понятно',
    profile__page__iin: 'ИИН',
    profile__page__addres: 'Адрес',
    profile__page__mail: 'Почта',
    profile__page__send__notif: 'Отправить уведомление о прибытии гостя',
    profile__page__edit__password: 'Изменить пароль',
    profile__page__add__addres: 'Добавить адрес',
    list__guest__title: 'Список моих гостей',
    edit__password__modal__title: 'Изменить пароль',
    edit__modal__form__label__old__password: 'Старый пароль',
    edit__modal__form__label__new__password: 'Новый пароль',
    edit__modal__form__label__repeat__new__password: 'Повторить новый пароль',
    edit__modal__form__btn: 'Сохранить',
    add__addres__page__title: 'Добавить адрес',
    add__addres__page__form__label__obl: 'Область',
    add__addres__page__form__label__district: 'Район',
    add__addres__page__form__label__locality: 'Населенный пункт',
    add__addres__page__form__label__addres: 'Адрес',
    add__addres__page__form__label__house: 'Номер дома', 
    add__addres__page__form__label__apartment_number: 'Номер квартиры', 
    add__addres__page__form__btn: 'Добавить', 
    address__list__title: 'Мои адреса',
    notif__add__title: 'Отправить уведомление о прибытии гостя в МВД',
    notif__scan__document: 'Сканирование документа',
    notif__scan__btn: 'Сканировать документ',
    notif__guest__info: 'Данные гостя',
    notif__identity__documents: 'Документы, удостоверяющие личность',
    notif__stay__details: 'Данные о пребывании',
    notif__send__data__btn: 'ОТПРАВИТЬ',
    notif__send__email__checkbox: 'Отправить welcome сообщение на email.',
    notif__send__mvd__checkbox: 'Отправить уведомление в МВД РК о прибытии иностранного постояльца.',
    notif__input__label__ar__dep: 'Дата заезда - выезда',
    notif__input__label__time: 'Время заезда',
    notif__input__label__addres: 'Адрес прибывания',
    notif__input__label__name: 'Имя',
    notif__input__label__last__name: 'Фамилия',
    notif__input__label__middle__name: 'Отчество',
    notif__input__label__citinzeship: 'Гражданство',
    notif__input__label__date_of_birth: 'Дата рождения',
    notif__input__label__gender: 'Пол',
    notif__input__label__phone: 'Телефон',
    notif__input__label__email: 'E-mail',
    notif__input__label_identification_document: 'Тип документа',
    notif__input__label__doc__num: 'Номер документа',
    notif__input__label__doc__series: 'Серия документа',
    notif__input__label__date_of_issue: 'Дата выдачи',
    notif__input__label__valid_through: 'Дата окончания срока',
    notif__input__label__purpose_of_visit: 'Цель визита',
    notif__input__label__arrival: 'Дата начала',
    notif__input__label__departure: 'Дата окончания',
    notif__input__label__additional_information: 'Дополнительные сведения',
}   